import { createSelector } from 'reselect';
import { filter } from 'lodash';
import { ChatState, RootState } from '../../store/state';

export const selectChatState = (state: RootState) => state?.chat;

export const selectChats = createSelector(
  selectChatState,
  (state: ChatState) => state?.chats
);


export const selectChatData = createSelector(
  selectChatState,
  (state: ChatState) => (chatChannel: string) =>  state?.chats?.[chatChannel]
)

export const selectUnreadChats = createSelector(
  selectChatState,
  (state: ChatState)  =>  filter(state?.chats, (chat => chat?.unreadMessagesCount > 0))?.length ?? 0
)

